import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { ComplementArea } from "./Styles";

export default function Complement({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Complemento"
            value={!value ? document.isComplement.text : value}
          />
        </div>
      ) : (
        <ComplementArea>
          <Informative
            readonly={true}
            label="Complemento"
            value={!value ? document.isComplement.text : value}
          />
        </ComplementArea>
      )}
    </>
  );
}
